const errorMessageConsts = {
  SESSION_TIMEOUT:
    "🐀 🐀 🐀 Rats! Your session has timed out. \nYou'll have to start over to open a Chime account.",
  GENERAL_ERROR_MESSAGE:
    'Unfortunately, we are experiencing technical difficulties. Please try again later.',
  INVALID_ZIP: 'The ZIP code you entered is invalid.',
  GENERAL_BDAY_ERROR_MESSAGE: 'Please correct your date of birth',
  BLANK_BDAY_ERROR_MESSAGE: 'Please enter your date of birth',
  BLANK_BDAY_DAY_ERROR_MESSAGE: 'Please enter your day of birth',
  BLANK_BDAY_MONTH_ERROR_MESSAGE: 'Please enter your month of birth',
  BLANK_BDAY_YEAR_ERROR_MESSAGE: 'Please enter your year of birth',
  BDAY_UNDER_18_ERROR_MESSAGE: 'You must be at least 18 years old to sign up',
  BDAY_OVER_120_ERROR_MESSAGE: 'Please correct your date of birth',
  INVALID_USPS_ADDRESS:
    'The address you provided is not recognized by the US Postal Service as a valid address. Please use a different address as mail sent to this location may be returned.',
  INVALID_EMAIL: 'Invalid email.',
  GENERAL_INVALID_ADDRESS:
    'The address you provided is not recognized by the U.S. Postal Service as a valid physical address. Please provide another street address and keep in mind we cannot accept either a P.O. or R.R. Box address.',
  INCORRECT_VERIFICATION_CODE: 'That code wasn’t right. Try again?',
  EMAIL_VERIFICATION_ATTEMPTS_EXCEEDED:
    '⚠️ Having trouble? Double check your email address.',
  PHONE_VERIFICATION_ATTEMPTS_EXCEEDED:
    '⚠️ Having trouble? Double check your number.',
  ADDRESS_APARTMENT_MISSING:
    'The address you provided seems to be missing an apartment number. Did you forget to enter it?',
  INVALID_ADDRESS_GENERAL_DELIVERY:
    'You may not enter a General Delivery address',
};

const { INVALID_EMAIL, GENERAL_INVALID_ADDRESS } = errorMessageConsts;

export const errorKeyMappingForNewService = {
  email: INVALID_EMAIL,
  address: GENERAL_INVALID_ADDRESS,
  address_line1: GENERAL_INVALID_ADDRESS,
  address_city: GENERAL_INVALID_ADDRESS,
  address_state_code: GENERAL_INVALID_ADDRESS,
  address_zip_code: GENERAL_INVALID_ADDRESS,
};

export default errorMessageConsts;

/** Server error messages */

export const serverInvalidEmailMessage = 'Invalid email.';
